import { render, staticRenderFns } from "./Taches.vue?vue&type=template&id=3760ff40"
import script from "./Taches.vue?vue&type=script&lang=js"
export * from "./Taches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports